import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-cultural',
  templateUrl: './cultural.component.html',
  styleUrls: ['./cultural.component.scss']
})
export class CulturalComponent implements OnInit
{ 
  selectedLanguage = '';
  font = '';
  ContentData: any;
  News_event_data: any;
  foundnews: any;

  constructor(
    private appService: AppService,
  )
  {

  }

  ngOnInit(): void
  {
    // this.selectedLanguage = localStorage.getItem('selectedLanguage');

    this.FetchData();
  }

  FetchData()
  {

    this.appService.getContents()
      .subscribe((response: any) =>
      {
        console.log(response, 'response FetchData');


        this.ContentData = response.data;
        console.log(this.ContentData, "proyash Content Data")

        if (this.ContentData != null)
        {
          let news = this.ContentData.filter(
            (x) => x.ContentCategoryName == "Cultural"
          );
          this.News_event_data = news;
          // this.foundnews = this.News_event_data.ShowAttachments;
          console.log(this.News_event_data, "All sports Data",);
        }

      });
  }

  GetFontName()
  {
    switch (this.selectedLanguage)
    {
      case 'en':
        return 'Congenial';
      case 'bn':
        return 'Kalpurush';
      case 'ar':
        return 'Jameel Noori Nastaleeq';
    }
  }
}
